import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './HomeServices.css';

const HomeServices = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Home Services Services | Digi Network" 
                description="Learn more about our Home Services services to grow your business online with Digi Network." 
                canonical="/industries/homeservices/homeservices" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Home Services Industry</div>
                        <h1>Digital Marketing for Home Services</h1>
                        <p>Generate qualified leads, book more jobs, and grow your home services business with targeted digital marketing for contractors and service providers. We understand the unique challenges home service businesses face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Home Services Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Home Services Marketing</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for contractors and service providers</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Home Services SEO</h3>
                            <p>Rank for local service searches, attract homeowners, and dominate your service area. Our home services SEO strategies help contractors dominate local search results and attract qualified leads.</p>
                            <ul>
                                <li>Local SEO for contractors</li>
                                <li>Service area optimization</li>
                                <li>Google My Business for services</li>
                                <li>Review management</li>
                                <li>Service directory listings</li>
                                <li>Project gallery optimization</li>
                            </ul>
                            <Link to="/industries/home-services/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Home Services Paid Ads</h3>
                            <p>Drive qualified leads and book more jobs with targeted advertising campaigns. Our targeted ad campaigns reach homeowners actively searching for your services.</p>
                            <ul>
                                <li>Google Ads for contractors</li>
                                <li>Facebook & Instagram ads</li>
                                <li>Service promotion campaigns</li>
                                <li>Lead generation ads</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/home-services/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Home Services Website Design</h3>
                            <p>Professional contractor websites with service information, online booking, and project galleries. Our contractor websites are designed to showcase your work and make it easy for customers to book.</p>
                            <ul>
                                <li>Contractor websites</li>
                                <li>Online booking systems</li>
                                <li>Project showcase galleries</li>
                                <li>Service area pages</li>
                                <li>Mobile-responsive design</li>
                                <li>Quote request forms</li>
                            </ul>
                            <Link to="/industries/home-services/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Home Services Email Marketing</h3>
                            <p>Nurture leads, book appointments, and drive repeat business with automated campaigns. Build lasting relationships with customers through strategic email communication that provides value.</p>
                            <ul>
                                <li>Lead nurturing sequences</li>
                                <li>Service reminder emails</li>
                                <li>Seasonal promotion campaigns</li>
                                <li>Customer retention programs</li>
                                <li>Project follow-up emails</li>
                                <li>Referral program campaigns</li>
                            </ul>
                            <Link to="/industries/home-services/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Home Services CRM & Automation</h3>
                            <p>Manage leads, automate follow-ups, and track jobs with GoHighLevel for contractors. Streamline your lead management and job tracking workflows to improve efficiency.</p>
                            <ul>
                                <li>Lead management system</li>
                                <li>Automated quote follow-ups</li>
                                <li>Job scheduling automation</li>
                                <li>Customer communication</li>
                                <li>Job tracking & reporting</li>
                                <li>Customer satisfaction tracking</li>
                            </ul>
                            <Link to="/industries/home-services/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title" >Our Home Services Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for contractors and service providers</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Business Analysis</h3>
                            <p>We analyze your home services business, target customers, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and lead generation strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Lead Generation Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on generating qualified leads who are ready to book your services. Every tactic is designed to convert interested prospects into paying customers.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from SEO to paid ads to email. Our team handles everything from website optimization to ad campaign launches.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Job Booking & Growth</h3>
                            <p>We continuously monitor performance, analyze customer feedback, and optimize campaigns for better results. Regular reporting keeps you informed of your lead generation and job booking metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Home Services Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Home Services Businesses Choose Digi Network</h2>
                    <p className="why-intro">Trusted by contractors and service providers across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Lead Generation Focus</h3>
                            <p>Every strategy is designed to generate qualified leads who are ready to book your services. We understand that home service businesses need a steady stream of leads to grow.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Local Market Expertise</h3>
                            <p>We understand local service markets and create campaigns that attract homeowners in your area. Our team has extensive experience working with contractors and service providers.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Job Booking Focus</h3>
                            <p>We optimize for conversions that result in actual job bookings, not just website visits. Our strategies focus on turning leads into booked jobs.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped home service businesses increase bookings by 400%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your business.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Home Services Businesses</h2>
                    <p className="section-intro">How our marketing services help you grow your home services business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Qualified Leads</h3>
                            <p>Generate more qualified leads through targeted marketing campaigns that reach homeowners actively looking for your services. Our strategies focus on converting high-intent searches into job bookings.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Online Visibility</h3>
                            <p>Dominate local search results for your services and build a strong online presence. When homeowners search for your services, they'll find your business first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Improved Customer Trust</h3>
                            <p>Build credibility and trust through professional online presence, positive reviews, and project galleries. Homeowners are more likely to choose contractors with strong online reputations.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Streamlined Operations</h3>
                            <p>Automate lead follow-ups, job scheduling, and customer communication to reduce administrative burden and improve efficiency.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better ROI Tracking</h3>
                            <p>Understand exactly which marketing channels deliver the best results with comprehensive tracking and reporting. Make data-driven decisions about your marketing spend.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many home service businesses still rely on outdated marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Home Services Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Book More Jobs?</h2>
                    <p>Let's discuss how we can help you attract more customers and grow your home services business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default HomeServices;
